export const TROUBLESHOOT_GUIDE_DRAWER_CLOSE_CLICK = '[Troubleshoot Guide] close drawer click'
